import React from 'react';
import { Handle, Position } from 'reactflow';
import {
  FileText, FileSpreadsheet, FileCode, File, Download, X,
} from 'lucide-react';
import { internalFileIdFromUrl, openFileInNewTab } from '../../api/filesApi';

function outputIcon(filename = '', mimeType = '') {
  const name = filename.toLowerCase();
  if (name.endsWith('.pdf') || mimeType.includes('pdf'))
    return <FileText size={28} className="tool-output-icon--pdf" />;
  if (name.endsWith('.xlsx') || name.endsWith('.csv') || mimeType.includes('spreadsheet') || mimeType.includes('csv'))
    return <FileSpreadsheet size={28} className="tool-output-icon--sheet" />;
  if (name.endsWith('.json') || name.endsWith('.py') || name.endsWith('.js'))
    return <FileCode size={28} className="tool-output-icon--code" />;
  return <File size={28} className="tool-output-icon--generic" />;
}

const ToolOutputNode = ({ data }) => {
  const { filename, fileUrl, mimeType, toolName, onDelete } = data;
  // Authenticated fileserver URLs need a signed link (no auth cookie any more);
  // public URLs (/public/files/...) open directly.
  const internalFileId = internalFileIdFromUrl(fileUrl);

  return (
    <div className="tool-output-node">
      <button
        className="delete-btn"
        onClick={(e) => { e.stopPropagation(); onDelete && onDelete(); }}
      >
        <X size={11} />
      </button>

      <Handle type="target" position={Position.Top} style={{ backgroundColor: '#6366f1' }} />

      <div className="tool-output-body">
        <div className="tool-output-icon">
          {outputIcon(filename, mimeType || '')}
        </div>
        <div className="tool-output-meta">
          <div className="tool-output-filename" title={filename}>{filename || 'output'}</div>
          {toolName && <div className="tool-output-source">via {toolName}</div>}
        </div>
      </div>

      {fileUrl && internalFileId && (
        // Authenticated file: a real href would 401 on middle-click / copy-link,
        // so render a button that fetches a signed URL on click.
        <button
          type="button"
          className="tool-output-download"
          onClick={(e) => {
            e.stopPropagation();
            openFileInNewTab(internalFileId).catch(() => {});
          }}
        >
          <Download size={13} /> Download
        </button>
      )}
      {fileUrl && !internalFileId && (
        <a
          className="tool-output-download"
          href={fileUrl}
          target="_blank"
          rel="noopener noreferrer"
          onClick={(e) => e.stopPropagation()}
        >
          <Download size={13} /> Download
        </a>
      )}

      <Handle type="source" position={Position.Bottom} style={{ backgroundColor: '#6366f1' }} />
    </div>
  );
};

export default ToolOutputNode;
